import React from 'react';
import styled, { css } from 'styled-components';

import { useCardContext } from './card-context';

type CardNameProps = {
  /** When true, scales font to 16px on desktop (list card behaviour). */
  responsive?: boolean;
};

/** Product name, truncated to 2 lines. */
export function CardName({ responsive = false }: CardNameProps = {}): JSX.Element {
  const { productName } = useCardContext();

  return <Name $responsive={responsive}>{productName}</Name>;
}

const Name = styled.div<{ $responsive?: boolean }>`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: #121516;
  display: -webkit-box;
  font-size: 14px;
  font-weight: 600;
  line-height: ${16 / 14};
  overflow: hidden;

  ${({ $responsive }) =>
    $responsive &&
    css`
      @media screen and (min-width: 740px) {
        font-size: 16px;
        line-height: ${18 / 16};
      }
    `}
`;
